import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import Field from '../field'
import useRoyalMailAddressAutocomplete from '../../hooks/use-royal-mail-address-autocomplete'

const RoyalMailAddressAutocomplete = ({
    field,
    countryCode,
    enabled = false,
    keyType,
    onAddressSelected
}) => {
    useRoyalMailAddressAutocomplete({
        countryCode,
        enabled,
        keyType,
        onAddressSelected
    })

    return null
}

RoyalMailAddressAutocomplete.propTypes = {
    field: PropTypes.object.isRequired,
    countryCode: PropTypes.string,
    enabled: PropTypes.bool,
    keyType: PropTypes.oneOf(['accountAddressBook', 'checkout']).isRequired,
    onAddressSelected: PropTypes.func.isRequired
}

export default RoyalMailAddressAutocomplete